import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { listOfDeliveryAndReceiptOfSmallSupplies } from "../docxTemplate/delivery-receipt-supplies";
import { exportRepairTicket } from "../docxTemplate/repair-ticket";
import { TableHelpers } from "../../../../../helper/TableHelper";
import { requestStatus } from "../../../../../constants";

export const useRepairToolColumns = () => {
  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "150px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: () => <span className="flag warning">Sửa chữa</span>,
      width: "100px",
    },
    {
      title: "Loại thiết bị",
      dataIndex: "Title",
      key: "Title",
      ...TableHelpers.searchInput({ dataIndex: "Title" }),
    },
    {
      title: "Nguyên nhân",
      dataIndex: "eCause",
      key: "eCause",
      ...TableHelpers.searchInput({ dataIndex: "eCause" }),
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "150px",
      render: (text: string) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted,
        },
        {
          text: "Đang thực hiện",
          value: requestStatus.inProgress,
        },
        {
          text: "Tiến hành nghiệm thu",
          value: requestStatus.acceptance,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => record.eRequestStatus.indexOf(status) === 0,
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <>
          <Button
            title={"Xuất phiếu sữa chữa"}
            className=""
            variant="outline-info"
            onClick={(e: any) => {
              e.stopPropagation();
              exportRepairTicket(record);
            }}
          >
            <FontFa name="faFileWord" size={"xs"} />
          </Button>
          <Button
            title={"Xuất phiếu GNVT"}
            className="ml-2"
            variant="outline-info"
            onClick={(e: any) => {
              e.stopPropagation();
              listOfDeliveryAndReceiptOfSmallSupplies(record);
            }}
          >
            <FontFa name="faPrint" size={"xs"} />
          </Button>
        </>
      ),
    },
  ];
  return { columns };
};
